import ACTS from '../constants'

const defaultStatus = {
    step: 1,
    joinSurvey: null,
    errorUserId: 0,
    errorUserPwd: 0,
    errorUserPwd2: 0
}

export default (state = defaultStatus, action) => {
    switch(action.type) {
        case ACTS.JOIN_STEP:
            return {
                ...state,
                step: action.step,
                loading: true
            }
        case ACTS.MEMBER_CHECK_ID:            
            return {                
                ...state,
                errorUserId: action.payload.result === true ? 0 : 3 
            }
        case ACTS.CODE_LIST:        
            return {
                ...state,
                joinSurvey: action.payload.item['JOIN_SURVEY'].LIST
            }
        case ACTS.SURVEY_LIST_UNLOADED:
            let temp = {...state};
            delete temp.joinSurvey;

            return temp;
        case ACTS.MEMBER_CHECK_ERROR: 
            return {
                ...state,
                errorUserId: action.errorUserId !== undefined ? action.errorUserId : state.errorUserId,
                errorUserPwd: action.errorUserPwd !== undefined ? action.errorUserPwd : state.errorUserPwd,
                errorUserPwd2: action.errorUserPwd2 !== undefined ? action.errorUserPwd2 : state.errorUserPwd2
            }
        case ACTS.MEMBER_JOIN:         
            return {
                ...state,
                step: 3,
                //errorUserId: action.payload.data.result === 0 ? 3 : action.payload.data.result,
                complete: action.payload.result
            }
            
        default:        
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/join.js